import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjectIncM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.19531 5.0122C3.19531 7.22807 4.99163 9.02439 7.20751 9.02439H8.06117C9.61699 9.02439 10.8782 10.2856 10.8782 11.8415L10.8782 14.4024C10.8782 14.7325 11.1458 15 11.4758 15C11.8058 15 12.0734 14.7325 12.0734 14.4024V11.8415C12.0734 9.62559 10.277 7.82927 8.06117 7.82927H7.20751C5.65168 7.82927 4.39044 6.56802 4.39044 5.0122L4.39043 1.59756C4.39043 1.26754 4.1229 1 3.79287 1C3.46285 1 3.19531 1.26754 3.19531 1.59756L3.19531 5.0122Z"
        fill="var(--color-typo-primary)"
      />
      <path
        d="M1 5.43902C1 8.83356 3.75181 11.5854 7.14634 11.5854H8C8.37717 11.5854 8.68293 11.8911 8.68293 12.2683V14.4024C8.68293 14.7325 8.95047 15 9.28049 15C9.61051 15 9.87805 14.7325 9.87805 14.4024V12.2683C9.87805 11.2311 9.03722 10.3902 8 10.3902H7.14634C4.41186 10.3902 2.19512 8.17351 2.19512 5.43902V5.0122C2.19512 4.68217 1.92758 4.41463 1.59756 4.41463C1.26754 4.41463 1 4.68217 1 5.0122V5.43902Z"
        fill="#97B2C4"
      />
      <path
        d="M6.12195 4.58537C6.12195 5.62258 6.96278 6.46341 8 6.46341H8.85366C11.5881 6.46341 13.8049 8.68015 13.8049 11.4146V11.8415C13.8049 12.1715 14.0724 12.439 14.4024 12.439C14.7325 12.439 15 12.1715 15 11.8415V11.4146C15 8.0201 12.2482 5.26829 8.85366 5.26829H8C7.62283 5.26829 7.31707 4.96254 7.31707 4.58537V1.59756C7.31707 1.26754 7.04954 1 6.71951 1C6.38949 1 6.12195 1.26754 6.12195 1.59756V4.58537Z"
        fill="#97B2C4"
      />
    </svg>
  )
}
export const IconGeoObjectInc = createIcon({
  l: IconGeoObjectIncM,
  m: IconGeoObjectIncM,
  s: IconGeoObjectIncM,
  xs: IconGeoObjectIncM,
  name: 'IconGeoObjectInc',
})
